
import * as actions from '../actions/currentUserActionTypes';


const initialState = {     
  rid: "",
  firstname: "",
  lastname: "",
  username: "",
  language: "en",
  iconSmall: "",
  iconMedium: "",
  iconLarge: "",
  imageSmall: "",
  imageMedium: "",
  imageLarge: ""
}

function currentUser(state = initialState, action) {      
  switch (action.type) {
    case actions.CURRENT_USER_SET_RID:
      return {
        ...state, 
        rid: action.rid
      }
    case actions.CURRENT_USER_SET_FIRSTNAME:
      return {
        ...state, 
        firstname: action.firstname
      }
    case actions.CURRENT_USER_SET_LASTNAME:
        return {
          ...state, 
          lastname: action.lastname
        }
    case actions.CURRENT_USER_SET_USERNAME:
      return {
        ...state, 
        username: action.username
      }
    case actions.CURRENT_USER_SET_LANGUAGE:
      return {
        ...state, 
        language: action.language        
      }

    case actions.CURRENT_USER_SET_ICONSMALL:
      return {
        ...state, 
        iconSmall: action.iconSmall
      }
    case actions.CURRENT_USER_SET_ICONMEDIUM:
      return {
        ...state, 
        iconMedium: action.iconMedium
      }
    case actions.CURRENT_USER_SET_ICONLARGE:
      return {
        ...state, 
        iconLarge: action.iconLarge
      }

    case actions.CURRENT_USER_SET_IMAGESMALL:
      return {
        ...state, 
        imageSmall: action.imageSmall
      }
    case actions.CURRENT_USER_SET_IMAGEMEDIUM:
      return {
        ...state, 
        imageMedium: action.imageMedium
      }
    case actions.CURRENT_USER_SET_IMAGELARGE:
      return {
        ...state, 
        imageLarge: action.imageLarge
      }

    default:        
      return state
  } 
}

export default  currentUser;